/**
 * Purga de datos personales cacheados por el service worker. Se llama al
 * cerrar sesión: un teléfono compartido no debe conservar el rol de juego,
 * credencial ni fotos del usuario anterior.
 */

import { T123_API_CACHE, T123_UPLOADS_CACHE } from "./cacheNames";

type CacheDeleter = Pick<CacheStorage, "delete">;

const PERSONAL_CACHES = [T123_API_CACHE, T123_UPLOADS_CACHE];

export async function purgePersonalCaches(
  cacheStorage: CacheDeleter | undefined = typeof caches !== "undefined" ? caches : undefined,
): Promise<void> {
  if (!cacheStorage) return;
  await Promise.all(
    PERSONAL_CACHES.map(async (name) => {
      try {
        await cacheStorage.delete(name);
      } catch {
        // Best-effort: la purga nunca debe bloquear el logout.
      }
    }),
  );
}
